<template lang="pug">
  .section-layout(v-if="!is_create_page")
    .section-filter
      span.add-button(@click="goCreate()")
      .field-group.is-horizontal
        .field.name_keyword-wrapper
          label.label 关键字搜索
          custom-input(v-model="filter_data.keyword", placeholder="请输入活动名称", @keyupEnter="applyFilter")
        .field.is-narrow
          label.label 活动类型
          custom-select(v-model="filter_data.type", :list="content_type", nameField="type")
        .field.is-narrow
          label.label 品牌
          custom-select(v-model="filter_data.brand", :list="brand_list", nameField="brand_name", :show-search="true")
        .field
          a.button.primary(@click="applyFilter") 搜索
        .field
          a.button(@click="resetFilter") 重置
        .field
          a.button(@click="goPoster", style="white-space: nowrap;") 前往海报统计
      a.operation-link.right-text(@click="goQRcode") 想创建活动二维码?
      //- 海报预览
      slide-out-modal(v-if="slideVisible" @input="showAddModel")
        view-poster(:poster_info="poster_info")
      download-poster(ref='downloadPosterEle')
    empty-page(v-if="!list.length", :tip="'当前没有活动'")
    .content-wrapper.list-wrapper(v-if="list && list.length")
      .table-wrapper
        table.table
          thead
            tr
              td(width="350") 活动名称
              td(width="80") 封面图
              td(width="180") 品牌名称
              td(width="120") 活动类型
              td(width="150") 操作人
              td(width="150") 操作时间
              td(width="220") 操作
          tbody(v-if="list.length")
            tr(v-for="(item, index) in list")
              td
                .simple-td(v-text="item.title")
              td
                .icon-img(v-if="item.cover")
                  img(:src="item.cover")
                .simple-null(v-else) --
              td
                .simple-td.max-160(v-text="item.brand_name ? item.brand_name : '无'")
              td
                .simple-td(v-text="item.template_id ? '模板活动' : '自建活动'")
              td
                .simple-td {{item.operator_name ? item.operator_name : '--'}}
              td
                .simple-td(v-text="item.updated_at")
              td
                .operation-td
                  a.operation-link.left(@click="changeOpen(item.activity_id, item.is_open, item.template_id)")  {{item.is_open === 1 ? '下架' : '上架'}}
                  a.operation-link.left(@click="goStatistic(item.activity_id, item.template_id)")  数据统计
                  a.operation-link.left(@click="goCustomer(item.activity_id, item.template_id)")  报名用户
                  a.operation-link.left(@click="goEdit(item.activity_id, item.is_open, item.template_id, item.end_time)" v-if="item.is_open !== 1")  {{isTimedOut(item)}}
                  a.operation-link.left(@click="viewContent(item.activity_id, item.template_id)" v-else) 查看
                  a.operation-link.left(@click="deleteInfo(item.activity_id, item.is_open, item.template_id)")  删除
                  a.operation-link.left(v-if="item.poster_img" @click="showAddModel(item)") 海报预览
                  a.operation-link(v-if="item.poster_img" @click="downloadPoster(item)") 下载海报
        .tfoot(v-if="list.length")
          pagination(:pagination-data="pagination_data", @input="paging")
  .section-layout(v-else)
    .create-page
      .header-wrapper
        .nav-back-btn(@click="closeCreatePage")
        span.header-title 请选择一种活动类型
      .create-page-content
        .type-box(@click="$router.push({ name: 'contentTemplateCreate' })")
          .type-title 模板活动
          .type-desc
            span 壳牌活动模板海量提供
            span 轻松编辑快速创建活动
            span 一键生成活动分享海报
        .type-box(@click="$router.push({ name: 'contentCreate' })")
          .type-title 自建活动
          .type-desc
            span 多种自定义活动组件
            span 随心编辑创建活动
            span 活动数据跟踪统计
</template>

<script>
import { mapGetters } from 'vuex'
import CustomInput from '@/components/generics/form/CustomInput'
import CustomSelect from '@/components/generics/form/CustomSelect'
import Pagination from '@/components/generics/Pagination'
import filterTools from '@/mixins/utilities/filterTools'
import imageScale from '@/mixins/utilities/imageScale'
import EmptyPage from '@/components/generics/EmptyPage'
import SlideOutModal from '@/components/generics/SlideOutModal'
import Api from '@/mixins/modules/Content'
import ViewPoster from '@/components/content/modal/ViewPoster'
import DownloadPoster from './components/DownloadPoster'
export default {
  name: 'ContentList',
  mixins: [filterTools, imageScale, Api],
  components: {
    CustomInput,
    CustomSelect,
    EmptyPage,
    SlideOutModal,
    Pagination,
    ViewPoster,
    DownloadPoster,
  },
  data: () => {
    return {
      is_create_page: false, // 是否显示新建页面
      brand_list: [],
      content_type: [
        { type: '全部', id: 0 },
        { type: '模板活动', id: 1 },
        { type: '自建活动', id: 2 },
      ],
      filter_data: {
        brand: null,
        type: { type: '全部', id: 0 },
        keyword: '',
      },
      query_data: {},
      pagination_data: {
        current_page: 1,
        per_page: 20,
        last_page: 2,
        total: 0,
      },
      list: [],
      is_search: false,
      is_initiated: false,
      slideVisible: false, // 海报预览弹框显示状态
      poster_info: {}, // 海报信息
    }
  },
  computed: {
    ...mapGetters({
      currentStore: 'currentStore',
    }),
  },
  methods: {
    // 下载海报
    async downloadPoster (item) {
      let QrCode = await this.getActivityStoreQrCode(item.activity_id)
      let posterInfo = {
        store_name: this.currentStore.store_name,
        store_address: this.currentStore.address,
        qr_code: QrCode,
        poster_background: item.poster_img,
        store_phone: this.currentStore.business_phone[0],
      }
      this.$refs.downloadPosterEle.download(posterInfo, item.title)
    },
    /**
     * 判断活动时间是否过期从而改变文案
     * @param item 活动对象
     */
    isTimedOut (item) {
      let text = '编辑'
      // 自建、模板活动 且 活动时间已过期
      if (new Date() > item.end_time * 1000) {
        text = '查看'
      }
      return text
    },
    // 海报预览模态框
    async showAddModel (item) {
      // 关闭组件不请求接口
      if (!this.slideVisible) {
        let posterInfo = JSON.parse(JSON.stringify(item))
        posterInfo.start_time = this.changeDate(item.start_time).trim().replace(/-/g, '.')
        posterInfo.end_time = this.changeDate(item.end_time).trim().replace(/-/g, '.')
        posterInfo.store_name = this.currentStore.store_name
        posterInfo.address = this.currentStore.address
        posterInfo.store_phone = this.currentStore.business_phone[0]
        this.poster_info = posterInfo
        this.poster_info.qr_code = await this.getActivityStoreQrCode(item.activity_id)
      }
      this.slideVisible = !this.slideVisible
    },

    // 获取活动二维码（模板活动海报预览用）传活动id
    async getActivityStoreQrCode (id) {
      try {
        const { response, result } = await this.GetActivityStoreQrCodeApi({
          id,
        })
        if (response.status === 200 && result.code === 0) {
          return result.data.image
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取中央活动库详情数据失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动二维码失败',
          content: `错误：${err}`,
        })
      }
    },

    goQRcode () {
      this.$router.push({
        name: 'channelQRcodeEdit',
        query: {
          isAdd: true,
          from: 'contentList',
        },
      })
    },

    /**
     * 检查活动关联关系
     * @id 活动id
     */
    async checkRelation (id) {
      try {
        const { response, result } = await this.checkRelationApi({ activity_id: id })
        if (response.status === 200 && result.code === 0) {
          return result.data.is_change // 数据是否发生改变1:未改变,2:改变
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '检查活动关联关系失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '检查活动关联关系失败',
          content: `错误: ${err}`,
        })
      }
    },

    /**
     * 活动上下架
     * @id 活动id
     * @isOpen 是否上下架：1、上架，2、下架
     * @templateId 活动模板id,0代表自建活动
     */
    async changeOpen (id, isOpen, templateId) {
      const _this = this
      let text = isOpen === 1 ? '下架' : '上架'
      // 自建活动
      if (!templateId) {
        try {
          const { response, result } = await this.ChangeOpenActivityApi({
            activity_id: id,
            open: isOpen === 1 ? 2 : 1,
          })
          if (response.status === 200 && result.code === 0) {
            this.$store.dispatch('showMessage', {
              autoClose: true, // 控制弹框自动消失
              type: 'success',
              title: `活动${text}成功`,
              resolve: () => {
                this.fetchData()
              },
            })
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: `活动${text}失败`,
              content: `${result.message}`,
            })
          }
        } catch (err) {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: `活动${text}失败`,
            content: `错误: ${err}`,
          })
        }
      } else {
        // 模板活动
        if (text === '下架') {
          _this.$store.dispatch('showMessage', {
            title: '提示',
            content: '活动下架后，门店将无法进行该活动的推广，请确认是否下架？',
            isRejectable: 1,
            primary: '下架',
            resolve: async function () {
              try {
                const { response, result } = await _this.ChangeOpenActivityStoreApi({
                  activity_id: id,
                  status: 2,
                })
                if (response.status === 200 && result.code === 0) {
                  _this.$store.dispatch('showMessage', {
                    autoClose: true, // 控制弹框自动消失
                    type: 'success',
                    title: '活动下架成功',
                    resolve: () => {
                      _this.fetchData()
                    },
                  })
                } else {
                  _this.$store.dispatch('showMessage', {
                    type: 'failure',
                    title: '活动下架失败',
                    content: `${result.message}`,
                  })
                }
              } catch (err) {
                _this.$store.dispatch('showMessage', {
                  type: 'failure',
                  title: '活动下架失败',
                  content: `错误: ${err}`,
                })
              }
            },
          })
        } else {
          // 上架（模板活动上架操作先检查活动关联关系,数据是否发生改变1:未改变,2:改变）
          const relationType = await _this.checkRelation(id)
          if (Number(relationType) === 2) {
            _this.$store.dispatch('showMessage', {
              title: '提示',
              content: '活动配置的优惠券已发生改变，是否进行上架操作？',
              isRejectable: 1,
              primary: '上架',
              resolve: async function () {
                try {
                  const { response, result } = await _this.ChangeOpenActivityStoreApi({
                    activity_id: id,
                    status: 1,
                  })
                  if (response.status === 200 && result.code === 0) {
                    _this.$store.dispatch('showMessage', {
                      autoClose: true, // 控制弹框自动消失
                      type: 'success',
                      title: '活动上架成功',
                      resolve: () => {
                        _this.fetchData()
                      },
                    })
                  } else if (response.status === 200 && result.code === 10000) {
                    _this.$store.dispatch('showMessage', {
                      title: '提示',
                      content: '该模板内容缺少必填信息，请先完善后在进行上架！',
                      isRejectable: 1,
                      primary: '去编辑',
                      resolve: () => {
                        _this.$router.push({
                          name: 'contentTemplateCreate',
                          query: {
                            isEdit: true,
                            activity_id: id,
                          },
                        })
                      },
                    })
                  } else {
                    _this.$store.dispatch('showMessage', {
                      type: 'failure',
                      title: '活动上架失败',
                      content: `${result.message}`,
                    })
                  }
                } catch (err) {
                  _this.$store.dispatch('showMessage', {
                    type: 'failure',
                    title: '活动上架失败',
                    content: `错误: ${err}`,
                  })
                }
              },
            })
          } else if (Number(relationType) === 1) {
            try {
              const { response, result } = await _this.ChangeOpenActivityStoreApi({
                activity_id: id,
                status: 1,
              })
              if (response.status === 200 && result.code === 0) {
                _this.$store.dispatch('showMessage', {
                  autoClose: true, // 控制弹框自动消失
                  type: 'success',
                  title: '活动上架成功',
                  resolve: () => {
                    _this.fetchData()
                  },
                })
              } else if (response.status === 200 && result.code === 10000) {
                _this.$store.dispatch('showMessage', {
                  title: '提示',
                  content: '该模板内容缺少必填信息，请先完善后在进行上架！',
                  isRejectable: 1,
                  primary: '去编辑',
                  resolve: () => {
                    _this.$router.push({
                      name: 'contentTemplateCreate',
                      query: {
                        isEdit: true,
                        activity_id: id,
                      },
                    })
                  },
                })
              } else {
                _this.$store.dispatch('showMessage', {
                  type: 'failure',
                  title: '活动上架失败',
                  content: `${result.message}`,
                })
              }
            } catch (err) {
              _this.$store.dispatch('showMessage', {
                type: 'failure',
                title: '活动上架失败',
                content: `错误: ${err}`,
              })
            }
          }
        }
      }
    },
    // 内容列表
    async fetchData () {
      this.is_initiated = false
      try {
        const { response, result } = await this.GetActivityListApi({
          brand: this.query_data.brand ? this.query_data.brand.brand_id : '',
          keyword: this.query_data.keyword,
          page: this.pagination_data.current_page,
          per_page: this.pagination_data.per_page,
          activity_type: this.filter_data.type.id,
        })
        if (response.status === 200 && result.code === 0) {
          result.data.forEach(item => {
            item.updated_at = this.changeDateTime(item.updated_at)
          })
          this.list = result.data
          this.pagination_data = result.meta
          this.is_initiated = true
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取内容列表失败',
            content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取内容列表失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
    },
    // 搜索按钮
    applyFilter () {
      this.is_search = true
      for (let key in this.filter_data) {
        if (this.query_data.hasOwnProperty(key)) {
          this.query_data[key] = this.filter_data[key]
        }
      }
      this.pagination_data.current_page = 1
      this.fetchData()
    },
    // 重置
    resetFilter () {
      this.is_search = false
      this.pagination_data.current_page = 1
      this.filter_data.brand = null
      this.filter_data.keyword = ''
      this.filter_data.type = { type: '全部', id: 0 }
      this.query_data = JSON.parse(JSON.stringify(this.filter_data))
      this.fetchData()
    },
    // 重置部分参数，不发送请求
    resetParams () {
      this.filter_data.brand = null
      this.filter_data.type = { type: '全部', id: 0 }
      this.filter_data.keyword = ''
      this.query_data = JSON.parse(JSON.stringify(this.filter_data))
    },
    // 获取品牌列表
    async getBrandList () {
      try {
        const { response, result } = await this.BrandListApi({
          page: '1',
          per_page: '9999',
          is_page: 1,
        })
        if (response.status === 200) {
          this.brand_list = result.data
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取品牌列表出错',
            content: `出错啦！错误码：${response.status}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取品牌列表失败',
          content: `出错啦！错误码：${err}`,
        })
      }
    },
    /**
     * 添加
     */
    goCreate () {
      this.is_create_page = true
      // this.$router.push({
      //   name: 'contentCreate',
      // })
    },
    /*
    * 关闭新建活动页面
    */
    closeCreatePage () {
      this.is_create_page = false
    },
    /**
     * 去数据统计
     * @id 活动id
     * @templateId 活动模板id,0代表自建活动
     */
    goStatistic (id, templateId) {
      // 自建活动
      if (!templateId) {
        this.$router.push({
          name: 'contentStatistic',
          query: {
            id,
          },
        })
      } else {
        // 模板活动
        this.$router.push({
          name: 'contentStatisticTemplate',
          query: {
            id,
          },
        })
      }
    },
    /**
     * 去报名用户
     * @id 活动id
     * @templateId 活动模板id,0代表自建活动
     */
    goCustomer (id, templateId) {
      // 自建活动
      if (!templateId) {
        this.$router.push({
          name: 'contentCustomer',
          query: {
            id,
          },
        })
      } else {
        // 模板活动
        this.$router.push({
          name: 'contentCustomerTemplate',
          query: {
            id,
          },
        })
      }
    },
    /**
     * 去编辑
     * @id {int} 编辑的id
     * @isOpen 是否上下架：1、上架，2、下架
     * @templateId 活动模板id,0代表自建活动
     * @endTime 活动结束时间
     */
    goEdit (id, isOpen, templateId, endTime) {
      if (isOpen === 1) {
        this.$store.dispatch('showMessage', {
          autoClose: true, // 控制弹框自动消失
          type: 'failure',
          title: '活动正在上架中,请下架后再编辑',
          resolve: () => this.$emit('failure'),
        })
        return false
      }
      // 自建活动
      if (!templateId) {
        this.$router.push({
          name: 'contentEdit',
          query: {
            id,
            detail: +new Date() > endTime * 1000 ? 1 : 0,
          },
        })
      } else {
        // 模板活动
        this.$router.push({
          name: 'contentTemplateCreate',
          query: {
            isEdit: true,
            activity_id: id,
          },
        })
      }
    },
    /**
     * 删除提示
     * @id {int} 删除的id
     * @isOpen 是否上下架：1、上架，2、下架
     * @templateId 活动模板id,0代表自建活动
     */
    deleteInfo (id, isOpen, templateId) {
      if (isOpen === 1) {
        this.$store.dispatch('showMessage', {
          autoClose: true, // 控制弹框自动消失
          type: 'failure',
          title: '活动正在上架中,请下架后再删除',
          resolve: () => this.$emit('failure'),
        })
        return false
      }
      // 自建活动
      if (!templateId) {
        this.$store.dispatch('showMessage', {
          title: '提示',
          content: '该活动有可能已被轮播图等渠道关联，请查看后再确认删除？',
          isRejectable: 1,
          resolve: () => {
            this.removeApi(id)
          },
        })
      } else {
        // 模板活动
        this.$store.dispatch('showMessage', {
          title: '提示',
          content: '该活动有可能已被轮播图等渠道关联，请查看后再确认删除？',
          isRejectable: 1,
          resolve: () => {
            this.removeTemplateApi(id)
          },
        })
      }
    },
    /**
     * 删除接口（自建活动）
     * @id {int} 删除的id
     */
    async removeApi (id) {
      let _this = this
      if (!this.is_search) {
        this.resetParams() // 重置部分参数
      }
      // 确认删除：confirm: 1、不确认删除，2、确认删除
      try {
        const { response, result } = await this.DeleteActivityApi({
          activity_id: id,
          confirm: 2,
        })
        if (response.status === 200 && result.code === 0) {
          this.$store.dispatch('showMessage', {
            autoClose: true, // 控制弹框自动消失
            type: 'success',
            title: '删除成功',
            resolve: () => {
              // 如果当前页只剩一条数据 且 当前页不是第一页
              if (this.list.length === 1 && this.pagination_data.current_page > 1) {
                this.pagination_data.current_page--
              }
              _this.fetchData()
            },
          })
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '删除活动失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '删除活动失败',
          content: `错误: ${err}）`,
        })
      }
    },

    /**
     * 删除接口（模板活动）
     * @id {int} 删除的id
     */
    async removeTemplateApi (id) {
      let _this = this
      if (!this.is_search) {
        this.resetParams() // 重置部分参数
      }

      try {
        const { response, result } = await this.DeleteActivityStoreApi({
          activity_id: id,
        })
        if (response.status === 200 && result.code === 0) {
          this.$store.dispatch('showMessage', {
            autoClose: true, // 控制弹框自动消失
            type: 'success',
            title: '删除成功',
            resolve: () => {
              // 如果当前页只剩一条数据 且 当前页不是第一页
              if (this.list.length === 1 && this.pagination_data.current_page > 1) {
                this.pagination_data.current_page--
              }
              _this.fetchData()
            },
          })
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '删除活动失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '删除活动失败',
          content: `错误: ${err}）`,
        })
      }
    },

    /**
     * 分页处理
     * @status  分页的状态
     */
    paging (state) {
      this.pagination_data = state
      this.fetchData()
    },
    // 添加品牌库按钮
    createBrand () {
      this.$router.push({
        name: 'addBrandHouse',
        query: {
          edit: 1,
        },
      })
    },
    /**
     * 时间戳转年月日+时分秒
     * @val  时间戳
     */
    changeDateTime (val) {
      if (!val) {
        return ''
      }
      let date = new Date(val * 1000)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = this.judgeTime(date.getDate()) + ' '
      let h = this.judgeTime(date.getHours()) + ':'
      let m = this.judgeTime(date.getMinutes())
      return Y + M + D + h + m
    },

    /**
     * 时间戳转年月日+时分秒
     * @val  时间戳
     */
    changeDate (val) {
      if (!val) {
        return ''
      }
      let date = new Date(val * 1000)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = this.judgeTime(date.getDate()) + ' '
      return Y + M + D
    },

    /**
     * 时 分 格式化
     * @t  时分
     */
    judgeTime (t) {
      if (t < 10) {
        return '0' + t
      } else {
        return t
      }
    },
    // 去海报统计页面
    goPoster () {
      this.$router.push({
        name: 'posterStatistics',
      })
    },
    // ,id=活动id,
    /**
     * 去查看模板活动页面
     * @id 活动id
     * @templateId 模板id 0代表自建活动
     */
    viewContent (id, templateId) {
      if (templateId) {
        this.$router.push({
          name: 'contentView',
          query: {
            activity_id: id,
          },
        })
      } else {
        this.$router.push({
          name: 'contentEdit',
          query: {
            id,
            detail: 1,
          },
        })
      }
    },
  },
  mounted () {
    this.getBrandList()
  },
  // 导航守卫
  beforeRouteEnter (to, from, next) {
    /**
      * 判断是否属于同级页面
      * (由切换tab进入)
      */
    if (!from.meta.isSlibing) {
      to.meta.isOutside = true
    }
    /**
     * 是添加 且 不是返回(保存)
     * @save: 1(返回)
     */
    if ((from.name === 'contentCreate' && to.query.save !== 1)) {
      to.meta.isPreserve = true
    }
    next()
  },
  // keep-alive进入
  activated () {
    /**
     * 未点搜索按钮
     */
    if (!this.is_search) {
      this.resetParams() // 重置部分参数
    }
    /**
     * 由切换tab进入 或
     * 是添加 且 不是返回(保存)
     */
    if (this.$route.meta.isOutside || this.$route.meta.isPreserve) {
      this.resetFilter() // 重置全部参数
      this.$route.meta.isPreserve = false
      this.$route.meta.isOutside = false
      return
    }
    /**
     * 如果是返回不请求接口
     * @save: 1(返回)
     */
    if (Number(this.$route.query.save) !== 1) {
      this.fetchData()
      this.$route.meta.isPreserve = false
      this.$route.meta.isOutside = false
    }
  },

  // keep-alive退出
  deactivated () {
    this.is_create_page = false
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.right-text
  color #ffbb29 !important
  font-size 14px
.max-160
  max-width 160px !important
.icon-img
  height 36px
.icon-img img
  width 36px
  height 36px
.section-filter
  display flex
  justify-content space-between
.name_keyword-wrapper
  width 244px
.button
  align-items center
.give-icon
  display none
.left
  margin-right 10px !important
.add-icon
  display inline-flex
  width 16px
  height 16px
  background url('~@/assets/icons/button-add.svg') no-repeat center center
  background-size cover
  margin-right 6px
.gray
  color #989ba1
.justify-center
  justify-content center
.operation-link
  margin-right 0
.text-overflow
  text-overflow ellipsis
  white-space nowrap
  overflow hidden
// 新建活动页面
.create-page
  width 100%
  height 100%
  background #fff
.header-wrapper
  min-height 56px
  align-items center
  padding-left 32px
  border-bottom 1px solid line
  display flex
  justify-content flex-start
  align-items center
  position relative
.nav-back-btn
  position absolute
  top 12px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.header-title
  padding-left 30px
.create-page-content
  width 100%
  height calc(100% - 56px)
  display flex
  justify-content space-around
  align-items center
.type-box
  width 260px
  height 300px
  cursor pointer
  color #999
.type-box:hover
  opacity 0.8
.type-title
  width 100%
  height 80px
  background #ffc723
  display flex
  justify-content center
  align-items center
  font-size 40px
.type-desc
  width 100%
  height calc(100% - 80px)
  border 1px solid #888
  display flex
  flex-direction column
  justify-content center
  align-items center
  span
    margin-top 20px
  & span:first-child
    margin-top 0
</style>



// WEBPACK FOOTER //
// src/components/content/ContentList.vue